import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState';
import _ from 'lodash';

const codeReducer = (state = InitialState.codeReducer, action) => {
    switch (action.type) {
        case ActionType.READER_CODE_RESPONSE: {
            return {
                ...state,
                codeObject: _.assign(action.codeObject),
                error: _.assign(action.error)
            };
        }


        default: { return state; }
    }
};

export default codeReducer;